import { render, staticRenderFns } from "./washingFacilityPlanSafetyDetail.vue?vue&type=template&id=48f41ec7"
import script from "./washingFacilityPlanSafetyDetail.vue?vue&type=script&lang=js"
export * from "./washingFacilityPlanSafetyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f41ec7')) {
      api.createRecord('48f41ec7', component.options)
    } else {
      api.reload('48f41ec7', component.options)
    }
    module.hot.accept("./washingFacilityPlanSafetyDetail.vue?vue&type=template&id=48f41ec7", function () {
      api.rerender('48f41ec7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/wfp/washingFacilityPlanSafetyDetail.vue"
export default component.exports